import { Fragment } from 'react';
import { SignedIn, SignedOut } from '@clerk/clerk-react';
import { useQuery } from '@tanstack/react-query';
import { createFileRoute, useParams, useNavigate } from '@tanstack/react-router'
import Button from 'rsuite/Button';
import { PersonRole } from '@/models/person';
import { type InvitedPerson } from '@/models/invited-person';
import Authorizor from '@/util/authorizor';
import Authorized from '@/components/Authorized';
import Loading from '@/components/Loading';
import { getInvitedGuestInfo } from '@/api/service/competition.service';
import { keyGetInvitedGuestInfo } from '@/api/query-keys';
import styles from './review.module.css'

const route = '/review/$reviewId';

export const Route = createFileRoute(route)({
  component: ReviewPageComponent,
})

interface ReviewProps {
    reviewId: string;
    person?: InvitedPerson;
}

interface ErrorProps {
    error?: string;
}

function Error(props: ErrorProps) {
    const navigate = useNavigate();
    const handleGoHome = () => {
        navigate({ to: '/' });
    }
    return (
        <div className={styles.container}>
            <div className={styles.heading}>Ooops!</div>
            <div className={styles.message}>
                {props.error ?? "Invitation not found"}
            </div>
            <Button appearance="primary" onClick={handleGoHome}>Go to Start Page</Button>
        </div>
    )
}

function NavigateSignIn(props: ReviewProps) {
    const navigate = useNavigate();
    navigate({ to: `/?re=%2Freview%2F${props.reviewId}` });
    return null;
}

function Review(props: ReviewProps) {
    const navigate = useNavigate();
    if (!props.person?.valid) {
        return <Error error={props.person?.reason} />
    } else if (!props.person || !props.person?.jumpId) { 
        return <Error error="Failed to load invitation" />
    } else {
        Authorizor.setGuestTarget({ role: PersonRole.REVIEWER, jumpId: props.person.jumpId});
        navigate({ to: `/draftsubmission/${props.person.jumpId}` });
        return null;
    }
}

function AuthenticatedReview(props: ReviewProps) {
    const { data, isError, error, isLoading } = useQuery({
        queryKey: keyGetInvitedGuestInfo(props.reviewId), 
        queryFn: async () => getInvitedGuestInfo(props.reviewId)
    });

    if (isLoading) {
        return <Loading />
    } else if (isError) {
        return <Error error={error.message} />
    } else {
        return <Review reviewId={props.reviewId} person={data} />
    }
}

// function ReviewSignIn() {

//     return (
//         <div>Redirecting...</div>
//     )
// }

function ReviewPageComponent() {
    const { reviewId } = useParams({ from: route });

    return (
        <Fragment>
        <SignedIn>
            <Authorized>
                <AuthenticatedReview reviewId={reviewId} />
            </Authorized>
        </SignedIn>
        <SignedOut>
            <NavigateSignIn reviewId={reviewId} />
        </SignedOut>
        </Fragment>
    )

}
